/**
 * Pick Your Favorites
 * Main Application Controller
 *
 * Responsibilities:
 * - initialize all PYF controllers in the correct order
 * - avoid unreliable setTimeout initialization
 * - support Shopify Theme Editor section reloads
 * - prevent duplicate initialization
 */

window.PYF = window.PYF || {};


/* =====================================================
   CHECK REQUIRED FUNCTIONS
===================================================== */

PYF.checkRequiredFunctions = function() {
  const requiredFunctions = [
    "initState",
    "initBagSelector",
    "initProducts",
    "initSidebar",
    "initCart"
  ];

  const missingFunctions =
    requiredFunctions.filter(
      function(functionName) {
        return (
          typeof PYF[functionName] !==
          "function"
        );
      }
    );

  if (missingFunctions.length) {
    console.error(
      "PYF could not initialize. Missing functions:",
      missingFunctions
    );

    return false;
  }

  return true;
};


/* =====================================================
   INITIALIZE APPLICATION
===================================================== */

PYF.init = function() {
  const page =
    document.querySelector(
      ".pyf-page"
    );

  if (!page) {
    return;
  }

  if (!PYF.checkRequiredFunctions()) {
    return;
  }

  try {
    /*
     * Initialization order matters:
     *
     * 1. State must exist before all other controllers.
     * 2. Bag selector reads and updates state.
     * 3. Product cards read quantities from state.
     * 4. Sidebar renders state.
     * 5. Cart controller reads the finished bag.
     */
    PYF.initState();

    PYF.initBagSelector();

    PYF.initProducts();

    PYF.initSidebar();

    PYF.initCart();

    /*
     * Force one final synchronized render after every
     * controller has attached its event listeners.
     */
    if (
      typeof PYF.emitStateChange ===
      "function"
    ) {
      PYF.emitStateChange(
        "initialized"
      );
    } else {
      if (
        typeof PYF.renderProducts ===
        "function"
      ) {
        PYF.renderProducts();
      }

      if (
        typeof PYF.updateSelectedBagCard ===
        "function"
      ) {
        PYF.updateSelectedBagCard();
      }

      if (
        typeof PYF.updateSidebar ===
        "function"
      ) {
        PYF.updateSidebar();
      }
    }

    page.dataset.pyfInitialized =
      "true";

    console.log(
      "🍬 Pick Your Favorites initialized"
    );
  } catch (error) {
    console.error(
      "PYF initialization error:",
      error
    );
  }
};


/* =====================================================
   INITIALIZE WHEN DOCUMENT IS READY
===================================================== */

PYF.initializeWhenReady = function() {
  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      function() {
        PYF.init();
      },
      {
        once: true
      }
    );

    return;
  }

  PYF.init();
};


/* =====================================================
   SHOPIFY THEME EDITOR SUPPORT
===================================================== */

/**
 * Shopify reloads section HTML without refreshing
 * the entire browser page. Re-run initialization
 * whenever this section is loaded in the editor.
 */
document.addEventListener(
  "shopify:section:load",
  function(event) {
    const section =
      event.target;

    if (
      !section ||
      !section.querySelector(
        ".pyf-page"
      )
    ) {
      return;
    }

    PYF.init();
  }
);


/**
 * Refresh the visible interface when the section
 * becomes selected inside Shopify's Theme Editor.
 */
document.addEventListener(
  "shopify:section:select",
  function(event) {
    const section =
      event.target;

    if (
      !section ||
      !section.querySelector(
        ".pyf-page"
      )
    ) {
      return;
    }

    if (
      typeof PYF.renderProducts ===
      "function"
    ) {
      PYF.renderProducts();
    }

    if (
      typeof PYF.updateSelectedBagCard ===
      "function"
    ) {
      PYF.updateSelectedBagCard();
    }

    if (
      typeof PYF.updateSidebar ===
      "function"
    ) {
      PYF.updateSidebar();
    }
  }
);


/* =====================================================
   START APPLICATION
===================================================== */

PYF.initializeWhenReady();